module.exports = __webpack_public_path__ + "34c27ce5f44c953448e7a6900eddb3ed.svg";